export const MOBILE_WIDTH = 1024;
export const PAD_WIDTH = 1200;

// todo: something like Angular?  Breakpoint detection?
export function isMobile() {
    return window.innerWidth < MOBILE_WIDTH;
}

// todo: something like Angular?  Breakpoint detection?
export function isPad() {
    return window.innerWidth < PAD_WIDTH;
}

export function isDesktop() {
    return window.innerWidth >= 1400;
}

export function changedSizeBetweenMobileAndDesktop(oldWindowWidth: number): boolean{
    const oldWasPad = oldWindowWidth < PAD_WIDTH;
    const newIsPad = isPad();
    return oldWasPad !== newIsPad;
}